import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { endpoints } from '../endpoints';
import { ErrorService } from '../helpers/errorService';
import { ICustomEopSection } from '../models/eopSection';

@Injectable({
    providedIn: 'root'
})
export class CustomEopService {
    constructor(
        private http: HttpClient,
        private errorService: ErrorService
    ) { }

    getCustomEopByBuildingId(buildingId: any): Observable<{message: string; data: ICustomEopSection[]}> {
        let url = environment.apiBaseUrl + endpoints.customEopSectionsByBuildingId.replace(':buildingId', buildingId);
        return this.http.get<{message: string; data: ICustomEopSection[]}>(url).pipe(
            catchError(this.errorService.handleError)
        );
    }

    getCustomPageByPageId(pageId: string): Observable<{has_error: boolean, message: string, data: ICustomEopSection}> {
        const url = environment.apiBaseUrl + endpoints.getCustomPageByPageId.replace(':pageId', pageId);
        return this.http.get<{has_error: boolean, message: string, data: ICustomEopSection}>(url).pipe(
            catchError(this.errorService.handleError)
        );
    }

    createBuildingCustomPage(buildingId: string, pageTitle: string): Observable<{has_error: boolean, message: string, data: ICustomEopSection}> {
        const url = environment.apiBaseUrl + endpoints.createCustomEopSection.replace(':buildingId', buildingId);
        return this.http.post<{has_error: boolean, message: string, data: ICustomEopSection}>(url, { title: pageTitle }).pipe(
            catchError(this.errorService.handleError)
        );
    }

    updateCustomPage(pageId: string, data: ICustomEopSection): Observable<{has_error: boolean, message: string, data: ICustomEopSection}> {
        const url = environment.apiBaseUrl + endpoints.updateCustomEopSection.replace(':pageId', pageId);
        return this.http.put<{has_error: boolean, message: string, data: ICustomEopSection}>(url, data).pipe(
            catchError(this.errorService.handleSavingError)
        );
    }

    deleteCustomPage(pageId: string): Observable<{has_error: boolean, message: string, data: any}> {
        const url = environment.apiBaseUrl + endpoints.deleteCustomEopSection.replace(':pageId', pageId);
        return this.http.delete<{has_error: boolean, message: string, data: any}>(url).pipe(
            catchError(this.errorService.handleError)
        );
    }
    
}